'use client';

import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Hero from './Hero';
import Stats from './Stats';
import Problem from './Problem';
import HowItWorks from './HowItWorks';
import Features from './Features';
import Testimonials from './Testimonials';
import ROICalculator, { type CostMetrics } from './ROICalculator';
import FAQ from './FAQ';
import CTA from './CTA';
import Footer from './Footer';
import BookingModal from './BookingModal';
import { initEngagementTracking } from '../lib/analytics';
import { getVariantContent, type Variant } from '../lib/variants';

interface HomeClientProps {
  variant: Variant;
}

const HomeClient: React.FC<HomeClientProps> = ({ variant }) => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [metrics, setMetrics] = useState<CostMetrics>({
    monthlySavings: 3250,
    yearlySavings: 39000,
    aiMonthly: 3450,
    employeeMonthly: 8525,
  });

  const content = getVariantContent(variant);

  useEffect(() => {
    initEngagementTracking(variant);
    const params = new URLSearchParams(window.location.search);
    if (params.get('booking') === 'open') {
      setIsBookingModalOpen(true);
    }
  }, []);

  const openBooking = () => setIsBookingModalOpen(true);

  return (
    <div className="font-sans">
      <Navbar onOpenBooking={openBooking} brandLabel={content.brandLabel} />

      <main>
        <Hero onOpenBooking={openBooking} content={content.hero} />
        <Stats stats={content.stats} />
        <Problem content={content.problem} />
        <HowItWorks content={content.howItWorks} />
        <Features content={content.features} />
        <Testimonials testimonials={content.testimonials} />
        <ROICalculator onMetricsChange={setMetrics} />
        <FAQ questions={content.faq} />
        <CTA onOpenBooking={openBooking} content={content.cta} />
      </main>

      <Footer />

      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        title={content.modalTitle}
        description={content.modalDescription}
      />
    </div>
  );
};

export default HomeClient;
